// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-compress-solid';

export const Component = () => (
  <path d='M15.788 6.37 15.741.287l6.465 6.466.096.096h-6.034c-.335 0-.479-.144-.479-.479Zm.48 1.485h6.369v15.182c0 .431-.144.766-.432 1.054a1.408 1.408 0 0 1-1.053.43H4.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 3 23.037V1.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 4.485 0h10.297v6.37c0 .43.144.766.431 1.053.288.288.623.432 1.054.432Zm-1.485 9.818v-1.964H12.82v-1.963h-1.964v1.963h1.964v1.964h-1.964v1.963h1.964v1.963h-1.964v1.916h1.964v-1.916h1.963v-1.963H12.82v-1.963h1.963Z' />
);

export const viewBox = '0 0 25 25';
